










































import Vue from 'vue'
// import QuestionWithFreeformParaphrase from '@/components/QuestionWithFreeformParaphrase.vue'
import QuestionTextParaphrase from '@/components/QuestionTextParaphrase.vue'
import { FeedbackSubmitModel } from '@/models/FeedbackSubmitModel'
import { FeedbackRequestSharedModel } from '@/models/FeedbackRequestSharedModel'
import { QuestionViewModel } from '@/models/QuestionViewModel'
import { FreeFormAnswerModel } from '@/models/FreeFormAnswerModel'

export default Vue.extend({
  name: 'FeedbackSubmitter',
  components: {
    // QuestionWithFreeformParaphrase,
    QuestionTextParaphrase
  },
  data: () => ({
    feedbackRequest: {} as FeedbackRequestSharedModel,
    // needsParaphrase: true,
    submitted: false
  }),
  methods: {
    async onFeedbackSubmit () {
      let questions = (this.feedbackRequest && this.feedbackRequest.feedbackTemplate && this.feedbackRequest.feedbackTemplate.questions)
        ? this.feedbackRequest.feedbackTemplate.questions.map((q: QuestionViewModel) =>
          new FreeFormAnswerModel(q.id, q.origAnswerText, q.paraAnswerText, q.wasParaEdited))
        : null
      console.log(questions)
      if (questions) {
        await this.$store.dispatch('submitFeedback',
          new FeedbackSubmitModel(this.feedbackRequest.sharedId, questions))
          .then((response: any) => {
            console.log(response)
            this.submitted = true
          })
      }
    }
  },
  async mounted () {
    let sharedId = this.$router.currentRoute.params['feedbackRequestSharedId']
    await this.$store.dispatch('getFeedbackTemplateBySharedId', { sharedId: sharedId })
      .then(async (fr: FeedbackRequestSharedModel) => {
        if (!fr) {
          return Promise.reject(new Error('Oops, the feedback request you were looking for was not found'))
        }
        this.feedbackRequest = fr
        if (this && this.feedbackRequest && this.feedbackRequest.feedbackTemplate) {
          this.$emit('sub-title-change', this.feedbackRequest.feedbackTemplate.title)
        }
        return Promise.resolve(this.feedbackRequest)
      })
  }
})
